'use strict';

module.exports = {
  template: require('./performance-review-overview.html'),
  controller: require('./performance-review-overview.controller'),
  controllerAs: 'vm',

  bindings: {
    invites : '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-overview/index.js
 ** module id = 309
 ** module chunks = 0
 **/